export default {"src":"/_next/static/media/for-creators-2.3bf45ec4.svg","height":1346,"width":1440};